import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { NumberField } from '../../atoms';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Row, Col, Button, Spin, Input } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormActions } from '../../components';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import { FORM_CLASSIFIERS_PRICE_EDIT } from '../../constants/formKeys';
import { getClassifiersPriceChange } from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import {
  classifierViewFields,
  classifierFields,
} from '../../constants/classifier';
import { translateMonthClassificator } from '../../utils/translateHelpers';
import validateSchema from './validateSchema';
import classifiersStore from '../../utils/classifiersStore';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

export class ClassifierPriceEdit extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    selectedYear: PropTypes.number.isRequired,
    selectedMonth: PropTypes.number.isRequired,
    selectedPrice: PropTypes.number.isRequired,
    initialValues: PropTypes.object,
    changeClassifierPrice: PropTypes.func.isRequired,
  };

  onSubmit = async (values) => {
    const { changeClassifierPrice, onComplete } = this.props;
    await changeClassifierPrice(values);
    onComplete();
    await classifiersStore.update();
  };

  render() {
    const {
      t,
      onCancel,
      isLoading,
      selectedYear,
      selectedMonth,
      initialValues,
    } = this.props;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Spin spinning={isLoading}>
        <Form
          onSubmit={this.onSubmit}
          initialValues={initialValues}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_CLASSIFIERS_PRICE_EDIT} />
              <Row gutter={32}>
                <Col span={12}>
                  <div>{t('fieldYear')}:</div>
                  <Input
                    className="global-margin-top-10"
                    value={selectedYear}
                    disabled
                  />
                </Col>
                <Col span={12}>
                  {t('fieldMonth')}:{' '}
                  <Input
                    className="global-margin-top-10"
                    value={translateMonthClassificator(
                      selectedMonth.toString()
                    )}
                    disabled
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={24}>
                  <Field
                    className="date-field"
                    name={classifierViewFields.PRICE}
                    label={t('fieldPrice')}
                    component={NumberField}
                    isFloat
                    precision={2}
                    min={0.01}
                    step={0.01}
                  />
                </Col>
              </Row>
              <FormActions>
                <Button onClick={onCancel}>{t('buttonCancel')}</Button>
                <Button htmlType="submit" type="primary">
                  {t('buttonSave')}
                </Button>
              </FormActions>
            </form>
          )}
        />
      </Spin>
    );
  }
}

const getIsLoading = getLoadingSelector(getClassifiersPriceChange);

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
    [classifierViewFields.PRICE]: ownProps.selectedPrice,
    [classifierFields.ID]: ownProps.classifierId,
  },
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  changeClassifierPrice: actions.changeClassifierPrice,
};

export default withTranslation(NAMESPACES.classifiers)(
  connect(mapStateToProps, mapDispatchToProps)(ClassifierPriceEdit)
);
